const Share = () => (
  <>
    <path
      fill="currentColor"
      d="M12.003 2.021q.158 0 .295.053t.268.184l3.388 3.388a.5.5 0 0 1 .15.344.47.47 0 0 1-.15.364.5.5 0 0 1-.354.16.5.5 0 0 1-.354-.16L12.5 3.608V13.5q0 .213-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.48.48 0 0 1-.143-.356V3.608L8.754 6.354a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.16-.354.5.5 0 0 1 .16-.354l3.389-3.388a.8.8 0 0 1 .27-.184.8.8 0 0 1 .297-.053"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 10.5A1.5 1.5 0 0 0 6 12v6a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 18v-6a1.5 1.5 0 0 0-1.5-1.5h-1.25a.5.5 0 0 1 0-1h1.25A2.5 2.5 0 0 1 19 12v6a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18v-6a2.5 2.5 0 0 1 2.5-2.5h1.25a.5.5 0 0 1 0 1z"
      clipRule="evenodd"
    />
  </>
)
export default Share
